import React from "react";

const DEFAULT_BG =
  "/assets/unsplash-1486325212027.jpg";

/**
 * PageHero — reusable hero header for sub-pages.
 * Building / environmental background tinted in UNIK navy.
 */
export default function PageHero({ eyebrow, title, sub, accent, bgImage = DEFAULT_BG }) {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-36 pb-20 lg:pt-44 lg:pb-24 overflow-hidden bg-[#14355a] text-white min-h-[58vh] flex items-end"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={bgImage} alt="" className="w-full h-full object-cover" />
        {/* Strong navy gradient — keeps the blue brand touch and ensures legibility */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#0e2540]/85 via-[#14355a]/70 to-[#14355a]/85" />
        <div className="absolute inset-0 bg-[#14355a]/35" />
      </div>
      <div className="absolute inset-0 grain pointer-events-none opacity-[0.05]" />

      <div className="relative z-10 mx-auto max-w-[1400px] w-full px-6 lg:px-24">
        <div
          className="fade-in eyebrow text-unik-gold"
          style={{ animationDelay: "0.1s" }}
        >
          {eyebrow}
        </div>

        <h1
          data-testid="page-hero-title"
          className="fade-in mt-6 font-display tracking-tight"
          style={{
            fontSize: "clamp(2rem, 4.5vw, 4rem)",
            fontWeight: 500,
            lineHeight: "1.05",
            animationDelay: "0.25s",
          }}
        >
          {title}
          {accent && <span className="text-unik-gold"> {accent}</span>}
        </h1>

        {sub && (
          <p
            className="fade-in mt-7 max-w-2xl text-white/85 text-[15px] lg:text-[17px] leading-[1.85]"
            style={{ animationDelay: "0.5s", fontWeight: 300 }}
          >
            {sub}
          </p>
        )}
      </div>
    </section>
  );
}
